import * as React from 'react';
import { create } from 'zustand';
import type { PageTourKey } from '@/lib/tours/registry';

interface PageTourReadyState {
  readyKeys: Record<string, boolean>;
  setReady: (key: PageTourKey, ready: boolean) => void;
  clearKey: (key: PageTourKey) => void;
  reset: () => void;
}

export const usePageTourReadyStore = create<PageTourReadyState>((set) => ({
  readyKeys: {},
  setReady: (key, ready) =>
    set((state) => ({
      readyKeys: { ...state.readyKeys, [key]: ready },
    })),
  clearKey: (key) =>
    set((state) => {
      const next = { ...state.readyKeys };
      delete next[key];
      return { readyKeys: next };
    }),
  reset: () => set({ readyKeys: {} }),
}));

export function usePageTourReady(tourKey: PageTourKey | null | undefined, isReady: boolean) {
  const setReady = usePageTourReadyStore((s) => s.setReady);
  const clearKey = usePageTourReadyStore((s) => s.clearKey);

  React.useEffect(() => {
    if (!tourKey) return undefined;
    setReady(tourKey, isReady);
    return () => {
      clearKey(tourKey);
    };
  }, [tourKey, isReady, setReady, clearKey]);
}
